import { useCallback, useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../store';
import {
  clearFilters,
  clearSelectedDetail,
  fetchClienteDetailThunk,
  fetchClientesThunk,
  setFilters,
  setLimit,
  setPage,
} from '../store/slices/clientes.slice';
import { ClientesFilters } from '../types/cliente';

export const useClientes = () => {
  const dispatch = useAppDispatch();
  const state = useAppSelector((s) => s.clientes);

  const refresh = useCallback(() => {
    return dispatch(
      fetchClientesThunk({
        page: state.page,
        limit: state.limit,
        ...state.filters,
      }),
    );
  }, [dispatch, state.page, state.limit, state.filters]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return {
    items: state.items,
    page: state.page,
    limit: state.limit,
    total: state.total,
    totalPages: state.totalPages,
    filters: state.filters,
    status: state.status,
    error: state.error,
    setFilters: (filters: ClientesFilters) => dispatch(setFilters(filters)),
    clearFilters: () => dispatch(clearFilters()),
    setPage: (page: number) => dispatch(setPage(page)),
    setLimit: (limit: number) => dispatch(setLimit(limit)),
    refresh,
  };
};

export const useClienteDetail = (id: string | undefined) => {
  const dispatch = useAppDispatch();
  const detail = useAppSelector((s) => s.clientes.selectedDetail);
  const detailStatus = useAppSelector((s) => s.clientes.detailStatus);
  const detailError = useAppSelector((s) => s.clientes.detailError);

  useEffect(() => {
    if (!id) return;
    dispatch(fetchClienteDetailThunk(id));
    return () => {
      dispatch(clearSelectedDetail());
    };
  }, [dispatch, id]);

  const refresh = useCallback(() => {
    if (id) dispatch(fetchClienteDetailThunk(id));
  }, [dispatch, id]);

  return { detail, status: detailStatus, error: detailError, refresh };
};
